module.exports = __webpack_public_path__ + "assets/date-range.4dae45f8.svg";